// extracted by mini-css-extract-plugin
module.exports = {"root":"sv","countbox":"sw","expireDate":"sx"};